import { render, staticRenderFns } from "./RescheduledEventSales.vue?vue&type=template&id=06c74c8c&scoped=true"
import script from "./RescheduledEventSales.vue?vue&type=script&lang=js"
export * from "./RescheduledEventSales.vue?vue&type=script&lang=js"
import style0 from "./RescheduledEventSales.vue?vue&type=style&index=0&id=06c74c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c74c8c",
  null
  
)

export default component.exports